import React, { useContext, useEffect } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { AppContext } from '../../contexts/app-context';
import { HtmlContent } from '../../global-component-styles';
import { redirectRoutePage, setWindowTitle } from '../../utils/helper';
import { LockedBackgroundImage } from '../../utils/icons';
import { Box, Button } from '../../utils/material-ui-core';

const AppLocked = () => {
  const pageStyles = LocalPageStyles();

  const { writeLog, appStatus } = useContext(AppContext);

  useEffect(() => {
    writeLog("Locked", "", "", "");
    setWindowTitle("App Locked");
    window.scrollTo(0, 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Box className={pageStyles.lockedMessageImageContainer}></Box>
      <Box className={pageStyles.lockedMessageContainer}>
        <HtmlContent dangerouslySetInnerHTML={{ __html: appStatus.message }}></HtmlContent>

        <Box p={5} display={"flex"} justifyContent={"center"}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              redirectRoutePage("Login");
            }}
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    lockedMessageContainer: {
      marginTop: "50px",
      textAlign: "left",
      "& h1": {
        fontSize: "1.2em",
        marginTop: "20px",
        textShadow: "1px 1px #c0c0c0",
        [theme.breakpoints.up("sm")]: {
          fontSize: "2em",
        },
      },
      "& p": {
        fontSize: "1em",
        marginTop: "10px",
        marginBop: "20px",
        letterSpacing: "1px",
        [theme.breakpoints.up("sm")]: {
          fontSize: "1.2em",
        },
      },
    },
    "@keyframes dashboardContainerAnimation": {
      from: { width: "200%", opacity: 0 },
      to: { width: "100%", opacity: 0.9 },
    },
    lockedMessageImageContainer: {
      margin: 0,
      spacing: 0,
      paddingTop: 0,
      marginBottom: 10,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      backgroundImage: `url(${LockedBackgroundImage})`,
      backgroundPosition: "center center",
      backgroundSize: "cover",
      animation: "$dashboardContainerAnimation 1s",
      transition: "all 0.5s ease-in-out 0s",
      minHeight: 400,
      [theme.breakpoints.up("sm")]: {
        minHeight: 500,
      },
    },
  })
);

export default AppLocked;
